import React, { Component } from 'react';
import { connect } from 'react-redux'
import {withRouter} from 'react-router-dom';

import Header from './Header'
import SideBar from './SideBar'
import MainContent from './MainContent'

import { pushOrderUpdate,pushOrderSummaryUpdate } from '../../OrdersTable/redux/orders' 
import { pushOrderStatisticsUpdate } from '../../OrdersTable/redux/order_statistics' 
import { pushGroupUpdate } from '../../OrderGroups/redux/ordergroups'
import { pushDailyMenuUpdate } from '../../DailyMenus/redux/dailymenus'
import { pushMessageUpdate } from '../../Wabox/redux/wabox' 
import Notifications , { Notify } from '../../Notifications/Components/Notifications'

//import {printKotImage} from '../../../common/helpers'

import { BulkPrintPreview } from '../../OrdersTable/Components'
//import { FinanceDetailsPrint } from '../../FinanceTable/Components/FinanceDetailsPrint'
//import { UpComingFinanceDetailsPrint } from '../../UpComingFinanceTable/Components/FinanceDetailsPrint'
//import { LTSModal } from '../../Modal/Components'
//import VacationModalLayout from './VacationModalLayout'

import MqttClient from '../../../services/mqtt/mqttclient'

import * as Constants from '../../../common/constants'

import '../../../static/css/custom.css'
import '../../../static/css/googlefonts.css'
import '../../../static/css/font-awesome.css'
import '../../../static/css/ionicons.css'
import '../../../static/css/adminlte.css'
import '../../../static/css/blue-skin.css'
import '../../../static/css/custom_bootstrap.css'
import '../../../static/css/bootstrap-datetimepicker.min.css'
// import '../../../static/css/custom_adminlte.css'

function displayNotification(title, message, level, uid) {
    let notificationDetails = {
      title: title,
      message: message,
      level: level,
      uid: uid
    }
    Notify().showNotification(notificationDetails)
}
class Dashboard extends Component {
  constructor() {
    super()
    this.state = {
      isVacationModalOpened: false,
      isSideBarOpened: true,
    }

    this.onSubscribe = this.onSubscribe.bind(this)
  }

  componentWillMount() {
    document.body.className = "sidebar-mini"
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions)
    this.updateDimensions()
    this.initializeMqtt()
    
  }

  initializeMqtt=()=>{
    let self = this
    let clientId=this.props.user.id+ '' +Math.random();
    if(this.props.user.mqtt_details){
    let mqtt_host = this.props.user.mqtt_details.connection_details.wss_host
    let mqtt_port = this.props.user.mqtt_details.connection_details.wss_port
    let willData = this.props.user.mqtt_details.offline_packet
    let mqtt_topics = this.props.user.mqtt_details.topics
    //let mqtt_online_packet = this.props.user.mqtt_details.online_packet
    const conOpts = { clientId, port: mqtt_port, host: mqtt_host, autoConnect: true, willData }
    MqttClient.connect(conOpts, function (err, data) {
      if (err) {
          console.error(`Error connecting mqtt: ${JSON.stringify(err)}`)
          
      } else {
          console.log(`${clientId} successfully connected`)
          
          //let mqttSubscribeTopics = {}
          Object.keys(mqtt_topics).map((index) => {
            MqttClient.subscribe({ topic: mqtt_topics[index].topic, qos: mqtt_topics[index].qos, callback : self.mqttMessageReceiver},self.onSubscribe)
              return ""
          })
          MqttClient.addConnectionStatusChangeCallback(self.onMqttConnectionStatusChange)
          
      }
    
  })
      }
}

mqttMessageReceiver = (data) => {
  let topic='',topicList=[]
  topicList= data.topic.split('/')
  
  let payload_details =null
  payload_details =JSON.parse(data.payload)

  if(this.props.user.user_type === Constants.SELLER_PROFILE){
    topic = topicList[3]
  }else{
    topic = topicList[1]
  }
  if(topic ===Constants.TOPIC_ORDER_LIST){
    let notification_message ="Order got updated"
    if(payload_details.status === Constants.NEW_REQUEST){
      notification_message ="New order received"
    }
    displayNotification("Order",notification_message,'info','tc')
  }
  if(topic ===Constants.TOPIC_ORDER_LIST && this.props.location.pathname ==='/dashboard/orders'){
    this.props.dispatch(pushOrderUpdate(payload_details))
    
  }
  if(topic ===Constants.TOPIC_ORDER_SUMMARY && this.props.location.pathname ==='/dashboard/orders'){
    this.props.dispatch(pushOrderSummaryUpdate(payload_details))
  }
  if(topic ===Constants.TOPIC_ORDER_STATISTIC && this.props.location.pathname ==='/dashboard/orderstatistic/list'){
    this.props.dispatch(pushOrderStatisticsUpdate(payload_details))
  }
  if(topic ===Constants.TOPIC_GROUP_LIST && this.props.location.pathname ==='/dashboard/ordergroup/list'){
    this.props.dispatch(pushGroupUpdate(payload_details))
  }
  if(topic ===Constants.TOPIC_DAILY_MENU_LIST && this.props.location.pathname ==='/dashboard/dailymenus'){
    this.props.dispatch(pushDailyMenuUpdate(payload_details))
  }
  if(topic ===Constants.TOPIC_MESSAGE_LIST && this.props.location.pathname ==='/dashboard/message/list'){
    this.props.dispatch(pushMessageUpdate(payload_details))
  }


  // if(this.props.user.user_type === Constants.SELLER_PROFILE && payload_details.status === Constants.CONFIRM_REQUEST){
  //   printKotImage(payload_details.kot_image)
  //   //SellerOrdersTable.PrintImage(orderPayload.kot_image)
  // }
  //find the current page
  //if current should get affected
    //store in localstorage
    
   
    //
  

}
onSubscribe(){

  }
  onMqttConnectionStatusChange=()=>{

  }
  updateDimensions = () => {
    if (window.innerWidth <= 767) {
      this.setState({ isSideBarOpened: false })
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
    MqttClient.disconnect();
  }

  isDashBoardNeeded = (data) => {
    let windowPath = data
    if (windowPath.includes("/dashboard/order/orderbulkpreview") || windowPath.includes("/dashboard/orderbulkpreview") ||
      windowPath.includes("/dashboard/orderbulkpreview")) {
      return false
    } else {
      return true
    }
  }

  onSidebarToggleButtonClick = () => {
    this.setState(Object.assign({}, this.state, { isSideBarOpened: !this.state.isSideBarOpened }))
  }

  toggleModal = (status) => {
    this.setState({ isVacationModalOpened: status })
  }

  render() {
    let dashboardComp = null
    if (this.isDashBoardNeeded(window.location.href)) {
      dashboardComp = (
        <div>
          <Header isSideBarOpened={this.state.isSideBarOpened} callBack={this.onSidebarToggleButtonClick} />
          <SideBar callBack={this.updateDimensions} openModal={this.toggleModal} />
          <MainContent {...this.props} />
        </div>
      )
    }else {
      dashboardComp = (
        <div>
          <BulkPrintPreview {...this.props} />
        </div>
      )
    }

    

    return (
      <div id="dashboard" className="lts"
        style={{
          backgroundColor: '#f0f0f0',
          position: 'absolute',
          bottom: '0px',
          right: '0px',
          left: '0px',
          top: '0px',
          height: '100%',
        }}>
        <Notifications />
        {dashboardComp}
        
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    app: state,
    user: state.user,
  }
}

export default connect(mapStateToProps)(withRouter(Dashboard))



// WEBPACK FOOTER //
// ./src/modules/Dashboard/Components/Dashboard.js